/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { HtmlAttributes } from "../../../../../Common/Constants/HtmlAttributes";
import { Logger } from "../../Logger";
import { isEventManagementForm } from "../../Utils/FormUtils";
var EventFormSerializer = /** @class */ (function () {
    function EventFormSerializer() {
    }
    EventFormSerializer.serialize = function (form, formElement, builder) {
        if (!formElement) {
            this.logger.error("Form is null");
            return;
        }
        if (!isEventManagementForm(form)) {
            return;
        }
        var submitButton = formElement.querySelector("[type='submit']");
        var eventSubmissionType = submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute(HtmlAttributes.dataEventSubmissionType);
        if (["registration", "waitlist", "eventRegistrationCancellation", "sessionRegistrationCancellation"].includes(eventSubmissionType)) {
            builder === null || builder === void 0 ? void 0 : builder.setEventSubmissionType(eventSubmissionType);
        }
    };
    EventFormSerializer.logger = new Logger();
    return EventFormSerializer;
}());
export { EventFormSerializer };
